export const SupplierFormType = {
    CREATE: 'create',
    UPDATE: 'update',
};
